import React, { Component } from 'react'
import { Cell } from 'styled-css-grid'
import { Icon } from 'semantic-ui-react'
import { observer } from 'mobx-react'
import cn from 'classnames'
import EditableField from '@ui/EditableField'
import Popup from '@ui/Popup'
import RadioButton from '@ui/RadioButton'
import RowItem from '@ui/RowItem'
import Container from './Container'
import './styles.scss'

@observer
export default class RowContainer extends Component {
  handleSelect = ({ value }) => {
    const { onSelect, selected, row } = this.props
    const { value: id } = row
    const newValues = { ...selected, [id]: value }
    if (onSelect) onSelect(newValues, id, value)
  }

  handleChangeTitle = text => {
    const { onEdit, row, index } = this.props
    onEdit(row, { index, text })
  }

  handleSave = () => {
    const { onSave, row } = this.props
    onSave(row)
  }

  render() {
    const {
      row,
      columns,
      selected,
      editable,
      onRemove,
      inactive,
      variablesOptions,
      textDirection
    } = this.props
    const { id, text, value, duplicated, focus, can_edit } = row
    const buttons = columns.map(column => ({
      ...column,
      id: `${text}-${column.value}`
    }))
    const currentValue = selected && value in selected ? selected[value] : undefined

    return (
      <RowItem
        id={id}
        editable={editable}
        onRemove={onRemove}
        className={cn('margin none', {
          hoverable: (editable && row.canShowSave) || onRemove
        })}
      >
        <Container
          columns={columns}
          editable={editable}
          textDirection={textDirection}
          className='ui-multiple-rating__row'
        >
          {editable && (
            <Cell className='flex no-space no-wrap move-button'>
              <Icon name='ellipsis vertical' />
              <Icon name='ellipsis vertical' />
            </Cell>
          )}
          <Cell className='ui-multiple-rating__row__title' middle>
            {editable && can_edit ? (
              <span>
                <EditableField
                  text={text}
                  editable={editable}
                  onBlur={this.handleChangeTitle}
                  options={variablesOptions}
                  size='extra-small'
                  focus={focus}
                  fitContent
                  required
                  light
                />
                {duplicated && (
                  <Popup
                    trigger={<Icon name='warning sign' className='yellow x16' />}
                  >
                    This value is duplicated
                  </Popup>
                )}
              </span>
            ) : (
              <span className='text dark'>
                {text}
                {editable && !can_edit && inactive && <Icon name='lock' />}
              </span>
            )}
          </Cell>
          {buttons.map(({ id, value }) => (
            <Cell key={value} middle>
              <RadioButton
                key={id}
                id={value}
                name={id}
                value={value}
                className='ui-multiple-rating__row__option'
                onChange={this.handleSelect}
                checked={currentValue === value}
                readOnly={inactive}
              />
            </Cell>
          ))}
        </Container>
        {editable && row.canShowSave && (
          <Popup
            triggerClassName='save-button flex centered'
            trigger={
              <Icon
                name={row.saveIcon}
                className='x16 cursor-pointer'
                onClick={this.handleSave}
                disabled={row.saveDisabled}
              />
            }
          >
            {row.saveTooltip}
          </Popup>
        )}
      </RowItem>
    )
  }
}
